<template>
  <div class="max-w-7xl mx-auto py-2 md:py-6 sm:px-6 lg:px-4">
    <section class="p-4 col-span-2">
      <card-with-header-and-footer-component :loading="lang.loading">
        <template v-slot:header>
          <h3 class="text-lg font-semibold leading-5 text-gray-900 sm:line-clamp-2">{{ $t("customization.lang") }}</h3>
        </template>
        <div>
          <label for="academy-name" class="block text-sm font-medium text-gray-700">{{ $t("customization.academy_lang") }}</label>
          <div class="mt-1">
            <select v-on:loadeddata="lang.options" v-model="academiesStore.academy.language_id"
                    class="form-select appearance-none block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none">
              <option v-for="option in lang.options" v-bind:key="option.id" :value="option.id">
                {{ option.name }}
              </option>
            </select>
          </div>
          <p class="mt-2 text-sm text-gray-500" id="academy-name-description">{{ $t("customization.academy_lang_selector_text") }}</p>
        </div>
        <template v-slot:footer>
          <button type="button" v-on:click="getAcademyLanguage" :disabled="lang.loading" class="mr-2 inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bpblue">
            {{ $t("general.cancel") }}
          </button>

          <button type="button" v-on:click="setLang" :disabled="lang.loading" class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-bpblue hover:bg-bpbluedeep focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bpblue">
            {{ $t("general.save") }}
          </button>
        </template>
      </card-with-header-and-footer-component>
    </section>
  </div>
</template>

<script>
import CardWithHeaderAndFooterComponent from "@/components/panels/CardWithHeaderAndFooterComponent";
import NotificationService from "@/services/notification/NotificationService";
import {useAuthUserStore} from "@/stores/auth";
import {useAcademiesStore} from "@/stores/academies";
import LanguageService from "@/services/settings/LanguageService";
import AcademyLanguageService from "@/services/academy/AcademyLanguageService";

export default {
name: "LanguageComponent",
  components: {
    CardWithHeaderAndFooterComponent
  },
  data() {
    return {
      lang: {
        loading: true,
        options: null,
        selectedLangId: null, //Select Input
        academyLangId: null,
      },
    }
  },
  setup(){

    const authUserStore = useAuthUserStore();
    const academiesStore = useAcademiesStore()

    return {
      authUserStore,
      academiesStore,
    }
  },
  created() {
    this.getLanguages()
  },
  methods: {
    getLanguages() {
      let academy_uuid = this.academiesStore.getSelectedAcademyUuid;
      this.lang.loading = true
      //Obtengo los idiomas.
      LanguageService.index(academy_uuid)
          .then((response) => {
            this.lang.options = response.data.data
            this.getAcademyLanguage()
            console.log("Se han obtenido los idiomas correctamente", this.lang.options)
          })
          .catch((response) => {
            console.log("Error obteniendo los idiomas", response)
            NotificationService.showNotification("Ha ocurrido un error inesperado", "error")
          })
          .finally(() => {
            this.lang.loading = false
          })
    },
    setLang() {
      let academy_uuid = this.authUserStore.user.academy.uuid;
      this.lang.loading = true
      let request = {
        academy_uuid: academy_uuid,
        language_id: this.academiesStore.academy.language_id
      }

        console.log("El idioma seleccionado es: ", this.academiesStore.academy.language_id)
        AcademyLanguageService.update(request)
            .then((response) => {
              console.log("Se ha almacenado el idioma correctamente: ", response)
            })
            .catch((error) => {
              console.log("Error al almacenar el idioma en la academia: ", error)
            })
            .finally(() => {
              this.lang.loading = false
            })
    },
    getAcademyLanguage() {
      this.lang.academyLangId = this.academiesStore.academy.language_id
      this.academiesStore.academy.languageName = this.lang.options.filter(lang => lang.id === this.lang.academyLangId)[0].name
      console.log("El lenguaje de la academia es: ", this.academiesStore.academy.languageName)
    },
  }
}
</script>

<style scoped>

</style>
